var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { UiIcon } from '@claims-ia/design-system';
import { changePageTitle } from '@declaration/services/changePageTitle';
let Forbidden = class Forbidden extends Vue {
    created() {
        const translate = this.$tc.bind(this);
        const routerBack = () => {
            this.$router.back();
        };
        const helpersContext = {
            store: this.$store,
            translate,
            routerBack,
        };
        changePageTitle(' ', helpersContext);
    }
};
Forbidden = __decorate([
    Component({
        components: {
            UiIcon,
        },
        meta: {
            goBack: null,
        },
    })
], Forbidden);
export default Forbidden;
